var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogosTelegram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logos:telegram",
    clipPath: "url(#clip0_786_671)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25 0C18.3711 0 12.0078 2.63555 7.32422 7.32227C2.63579 12.0108 0.00129871 18.3695 0 25C0 31.6277 2.63672 37.991 7.32422 42.6777C12.0078 47.3645 18.3711 50 25 50C31.6289 50 37.9922 47.3645 42.6758 42.6777C47.3633 37.991 50 31.6277 50 25C50 18.3723 47.3633 12.009 42.6758 7.32227C37.9922 2.63555 31.6289 0 25 0Z",
    fill: "url(#paint0_linear_786_671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.3172 24.7361C18.6063 21.5611 23.4657 19.4677 25.8954 18.4564C32.8407 15.5685 34.2821 15.0669 35.2235 15.05C35.4305 15.0466 35.8915 15.0978 36.1922 15.341C36.4422 15.546 36.5125 15.8234 36.5477 16.0181C36.579 16.2126 36.6219 16.656 36.5868 17.0021C36.2118 20.9552 34.5829 30.5482 33.7547 34.9759C33.4071 36.8494 32.7157 37.4775 32.0477 37.5388C30.5946 37.6724 29.493 36.5794 28.0868 35.658C25.8876 34.2154 24.6454 33.3177 22.5086 31.9103C20.0399 30.2837 21.6415 29.3896 23.0477 27.9287C23.4149 27.5462 29.8133 21.7279 29.9344 21.2001C29.95 21.1341 29.9657 20.888 29.8172 20.7584C29.6727 20.6283 29.4579 20.6728 29.3016 20.708C29.079 20.758 25.5672 23.0814 18.7547 27.6779C17.7586 28.363 16.8563 28.697 16.0438 28.6794C15.1532 28.6603 13.4344 28.1748 12.1571 27.7599C10.5946 27.2509 9.34849 26.9818 9.45786 26.1173C9.51255 25.6673 10.1336 25.2068 11.3172 24.7361Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_786_671",
    x1: 2500,
    y1: 0,
    x2: 2500,
    y2: 5000,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_786_671"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosTelegram);
export default __webpack_public_path__ + "static/media/logos_telegram.852c68cf260c1217e6c27ccd9d311bde.svg";
export { ForwardRef as ReactComponent };